export enum StatoCommessa {
  'APERTA',
  'COMPLETATA',
}
